import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProgressBar.scss';

export default class ProgressBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepNumber: this.props.defaultStepNumber
    };

    this.setStepNumber = this.setStepNumber.bind(this);
    this.icon = React.createRef();
  }

  setStepNumber = (stepNumber) => {
    if (typeof(stepNumber) === "number") {
      this.setState({ stepNumber });
    }
  } 

  render() {
    // Makes it so step 1 = 0% and last step = 100%
    let functionalTotalSteps = this.props.totalSteps - 1;

    let icon = (this.props.icon) ? this.props.icon : this.props.defaultIcon;

    return (
      <span> 
        <div className="progress-bar">
          <div className="progress-bar__container">
            <div className="progress-bar__indicator"></div>
            <div className="progress-bar__base" style={{ width: ((functionalTotalSteps - this.state.stepNumber + 1) / functionalTotalSteps * 100) + "%"}}></div>
          </div>
          <div className="progress-bar__icon-wrapper">
            <div className="progress-bar__icon js-progress-bar__icon" style={{ right: `calc(${((functionalTotalSteps - this.state.stepNumber + 1) / functionalTotalSteps * 100)}% - var(--icon-width))`}}>
              <img 
                alt={icon.altText}  
                className="progress-bar__icon-img"
                src={icon.path} 
                ref={(ref) => this.icon = ref}
              />
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ProgressBar.defaultProps = {
  defaultStepNumber: 1
};

ProgressBar.propTypes = {
  defaultIcon: PropTypes.shape({
    altText: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  defaultStepNumber: PropTypes.number,
  icon: PropTypes.shape({
    altText: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }),
  totalSteps: PropTypes.number.isRequired
};